var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanvasEventBuy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 89.9999,
    height: 89.9999,
    rx: 15,
    transform: "matrix(0.707107 0.707106 -0.707107 0.707106 64 0)",
    fill: "#17D3B4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 33.6396,
    width: 60,
    height: 59.9999,
    rx: 30,
    fill: "#DEFDF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 50.1396C58.8223 50.1396 54.625 53.1617 54.625 56.8896C54.625 60.6176 58.8223 63.6396 64 63.6396C69.1776 63.6396 73.375 66.6617 73.375 70.3896C73.375 74.1175 69.1777 77.1396 64 77.1396M64 50.1396C67.47 50.1396 70.4998 51.4971 72.1207 53.5146M64 50.1396V46.7646M64 50.1396L64 77.1396M64 77.1396L64 80.5146M64 77.1396C60.53 77.1396 57.5002 75.7822 55.8793 73.7646",
    stroke: "#17D3B4",
    strokeWidth: 3.75,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasEventBuy);
export default __webpack_public_path__ + "static/media/canvas_event_buy.b0bc0045baabfc80905c1e3306ffcd37.svg";
export { ForwardRef as ReactComponent };